export default __webpack_public_path__ + "static/media/priority@2x.982bff7e.svg";